
import { getToken, setToken, removeToken } from '@/utils/auth'
import { getLogin } from '@/api/login'
import { getleftMenu } from '@/api/leftMenu'
import { addRoutes } from '@/router'
const state = {
  token: getToken('token'),
  menus: [],
  hostConfig: getToken('hostConfig')
}

const mutations = {
  setToken: (state, token) => {
    state.token = token;
    setToken('token',token)
  },
  setUser: (state, hostConfig) => {
    state.hostConfig = hostConfig;
    setToken('hostConfig',hostConfig)
  },
  setMenus: (state, menus) => {
    state.menus = menus
  },
}

const actions = {
  async login({ commit }, paras) {
    const res = await getLogin(paras);
    //console.log(res)
    if (res.status == 200) {
      const token = res.data.accessToken;
      const hostConfig = JSON.stringify(res.data);
      commit('setToken', token);
      commit('setUser', hostConfig);
    }
    return res
  },

async getLoginInfo({ commit }) {
  //路由菜单数据
  const res = await getleftMenu();
  //console.log(res)
  if(res.status == 200){
    let rootMenu = res.data;
    commit('setMenus', rootMenu)
    addRoutes(rootMenu)
    return rootMenu
  }
  //console.log(res)
    // let rootMenu = [
    //   {
    //     id: "1",
    //     parentId: null,
    //     icon:'icon-fmxx',
    //     label: '阀门信息管理',
    //     opened:true,
    //     viewPath:null,
    //   },
    //   {
    //     id: "1-1",
    //     parentId: "1",
    //     icon:'icon-xh',
    //     label: '阀门型号管理',
    //     opened:false,
    //     viewPath:'/valve/model/index',
    //   },
    //   {
    //     id: "1-2",
    //     parentId: "1",
    //     icon:'icon-da',
    //     label: '阀门档案管理',
    //     opened:false,
    //     viewPath:'/valve/archives/index',
    //   },
    //   {
    //     id: "2",
    //     parentId: null,
    //     icon:'icon-jcxx',
    //     label: '基础信息管理',
    //     opened:true,
    //     viewPath:null,
    //   },
    //   {
    //     id: "2-1",
    //     parentId: "2",
    //     icon:'icon-zzdw',
    //     label: '制造单位管理',
    //     opened:false,
    //     viewPath:'/basic/manufacturing/index',
    //   },
    //   {
    //     id: "2-2",
    //     parentId: "2",
    //     icon:'icon-zh',
    //     label: '账号管理',
    //     opened:false,
    //     viewPath:'/basic/account/index',
    //   },
    // ]
    
  },

  logout({ commit }) {
    commit('setToken', '');
    commit('setUser', '');
    commit('setMenus', '');
    removeToken('token');
    removeToken('hostConfig')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
